import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../../_metronic/layout/core';
import * as Utilities from '../../../../Components/Utils/Utils';
import PermissionsGate from '../../../../api/PermissionsGate';
import { SCOPES } from '../../../../config/permissions-map';
import { Unauthorized } from '../../../Global/unauthorized';
import Vacancy from './Vacancy';


function MapaVistaGeneral_vacancy({ title }) {
    const lsUnidadEconomica = JSON.parse(sessionStorage.getItem("MapaVacancy"));

    const [unidadEconomica, setUnidadEconomica] = useState(
        lsUnidadEconomica != null ? lsUnidadEconomica : Utilities.getListUnidadesEconomicas().list[0]
    );
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();
    const getOptionUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        sessionStorage.setItem("MapaVacancy", JSON.stringify(inputValue));
        setUnidadEconomica(inputValue);
        // window.location.reload(false);
    }

    const animatedComponents = makeAnimated();

    const [vacancyData, setVacancyData] = useState({
        "areaArrendable": null,
        "vacancy": null
    });

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.MAPA_CALOR_VACANCY]} >
                <>
                    <PageTitle>{title}</PageTitle>
                    <div className="card my-5">
                        <div className="card-header pt-5 border-0" >
                            <div className="align-items-start flex-column">

                                <div className="d-flex align-items-center mb-3">
                                    <div className="p-2" style={{ minWidth: "200px" }}>
                                        <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                        <Select
                                            classNamePrefix='filter'
                                            components={animatedComponents}
                                            defaultValue={lsUnidadEconomica != null ? lsUnidadEconomica : getOptionUnidadEconomica(unidadesEconomicasList.defaultId)}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={unidadesEconomicasList.list}
                                            onChange={(onChangeUnidadEconomica)}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="card-toolbar" >
                                <div className="d-flex justify-content-end">
                                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fs-7 text-muted fw-bold">Área Arrendable</div>
                                        <div className="fs-4 fw-bolder " >{Utilities.comillasFix(vacancyData.areaArrendable, true)} m<sup>2</sup></div>
                                    </div>
                                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3">
                                        <div className="fs-7 text-muted fw-bold">Vacancy</div>
                                        <div className="fs-4 fw-bolder " >{Utilities.comillasFix(vacancyData.vacancy, true)}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body tab-content pt-0">
                            <Vacancy unidadEconomica={unidadEconomica} setVacancyData={setVacancyData}></Vacancy>
                        </div>
                    </div>
                </>
            </PermissionsGate>
        </>
    )
}

export default MapaVistaGeneral_vacancy
